import React, {useState} from "react";
import TaskView from "../common/TaskView";
import { AcousticTask, AcousticTaskDefinition } from "../common/models";
import { randomUUID } from "../../../utils";
import { translateReactNode } from "../../../../utils/translateReactNode";

const Definition: AcousticTaskDefinition = {
  name: 'Audio Check (v2)',
  cohort: 'generic',

  title: 'Audio Check',
  description: '',
  type: 'acoustic-task',
  estimatedCompletionTime: '0:45',
  subTaskDefinitions: [
  {
    name: 'Audio Check (v2)-1',
    title: "Speech 1",
    instructions: `Click on the Record button below and say something out loud like “Testing 1, 2, 3”. Recording will stop automatically after 5 seconds. Click Play to hear your recording. If you hear background noise, please go to a quieter place and try again by selecting Redo Recording. If it sounds good, continue.`,
    profileName: 'speech',
    stopwatchSeconds: 5,
    showGainSlider: true
  },
  {
    name: 'Audio Check (v2)-2',
    title: "Speech 2",
    instructions: `Use your typical volume and typical pitch to say “I am happy to participate in the Bridge2AI study”. Click the Record button before speaking and then the Stop button once you are done.`,
    profileName: 'speech',
    showGainSlider: true
  },
  {
    name: 'Audio Check (v2)-3',
    title: "Cough",
    instructions: `Click on the Record button below and cough hard as if there is something stuck in your throat. Recording will stop automatically after 5 seconds. Click Play to hear your recording. If you hear background noise, please go to a quieter place and try again by selecting Redo Recording. If it sounds good, continue.`,
    profileName: 'cough',
    stopwatchSeconds: 5,
    showGainSlider: true
  },
  {
    name: 'Audio Check (v2)-4',
    title: "Breathing",
    instructions: `Click on the Record button below and breathe deeply through your mouth. Continue to do this until the recording automatically stops after 5 seconds. Click Play to hear your recording. If you hear background noise, please go to a quieter place and try again by selecting Redo Recording. If it sounds good, continue.`,
    profileName: 'breathe',
    stopwatchSeconds: 5,
    showGainSlider: true
  },
  {
    name: 'Audio Check (v2)-5',
    title: "Background audio",
    instructions: `Please press record and sit quietly without speaking for 10 seconds. We are just recording the baseline noise in the room.`,
    profileName: 'speech',
    stopwatchSeconds: 10,
  }]
};
export const AudioCheckDefinition = Definition;

export const AudioCheck = ({onCompletion}: {onCompletion: () => void}) => {
  const [task, _setTask] = useState<AcousticTask>(() => ({
    ...Definition,
    id: randomUUID(),
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'pending',
    subTasks: Definition.subTaskDefinitions.map((definition) => ({
      ...definition,
      id: randomUUID(),
      instructions: translateReactNode(definition.instructions, Definition.cohort),
      title: translateReactNode(definition.title, Definition.cohort) as string
    }))
  }));

  const handleOnCompletion = () => {
    console.log("Audio Check completed");
    onCompletion();
  }

  return (
    <div>
      <TaskView
        task={task}
        onCompletion={handleOnCompletion}
        showAudioBar
      />
    </div>
  );
};
